import { createSlice } from "@reduxjs/toolkit";

const medicalResultsSlice = createSlice({
  name: "medicalResults",
  initialState: {
    resultsByClientId: {},
  },
  reducers: {
    setMedicalResultsByClientId(state, action) {
      state.resultsByClientId = action.payload || {};
    },
  },
});

export const { setMedicalResultsByClientId } = medicalResultsSlice.actions;
export default medicalResultsSlice.reducer;
